module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-12-19 at 20.13.02.5b9b6adb.jpeg";